export default __webpack_public_path__ + "static/media/plus_secondary.b791ccf3.svg";